module.exports = __webpack_public_path__ + "static/card-ed86e594720bfc5a2b83d24cf996b3fa.png";